module.exports = __webpack_public_path__ + "img/FM.2d1657d1.svg";